<template>
    <ul class="mai-nav-tabs-sub mai-sub-nav nav">
        <router-link :to="{name: route.target}" role="button" active-class="open" aria-expanded="false" tag="li" class="nav-item dropdown" v-for="route in items" :key="route.meta.label" exact>
            <a class="nav-link">
                <span :class="'icon ' + route.meta.icon"></span>
                <span>{{ $t(route.meta.label) }}</span>
            </a>
        </router-link>
    </ul>
</template>

<script>
    export default {
        props: ['items']
    }
</script>
<style>
    .mai-nav-tabs-sub > .nav-item > .nav-link .icon {
        font-weight: bold;
        font-size: 17px;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/menus/submenu.vue